export const headers = {
  initialHeaders: [
    { title: "Tipo de Contrato", field: "contractType", child: null },
    { title: "Estado", field: "status", child: null },
    { title: "Fecha inicial", field: "initialDate", child: null },
    {
      title: "Fecha final",
      field: "endDate",
      child: null,
    },
    {
      title: "Notificacion",
      field: "notification",
      child: null,
    },
  ],
};

export const defaultSearchValues = {
  contractType: null,
  status: null,
};

export const defaultValues = {
  documentNumber: false,
  rhInterview: false,
  leaderProcessInterview: false,
  status: false,
  psychotechnicalTest: false,
  knowledgeTest: false,
  medicalTest: false,
  vacant: false,
  rhInterviewRecommendations: "",
  leaderProcessInterviewRecommendations: "",
  psychotechnicalTestRecommendations: "",
  knowledgeTestRecommendations: "",
  medicalTestRecommendations: "",
};
